import { Combobox } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoiceDeliveryNotePickSchema } from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import { useFormContext } from "react-hook-form";
import { formatInvoiceDate } from "@/components/incoming-invoices";
import { useIncomingInvoiceDeliveryNotes } from "@/hooks/use-incoming-invoice-delivery-notes";

/** A delivery note still waiting for the invoice that bills it — one no invoice holds yet. */
export function IncomingInvoiceDeliveryNotePickForm() {
	/** Context */
	const methods = useFormContext<IncomingInvoiceDeliveryNotePickSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { deliveryNotes } = useIncomingInvoiceDeliveryNotes();

	/** Computed */
	const options = deliveryNotes.filter((deliveryNote) => !deliveryNote.invoice);

	/** Render */
	return (
		<Combobox
			control={methods.control}
			name="deliveryNoteId"
			options={options}
			displayValue={(deliveryNote) =>
				`${guardString(deliveryNote.number)} · ${guardString(deliveryNote.issuerName)} · ${formatInvoiceDate(deliveryNote.deliveryDate)}`
			}
			keyExtractor={(deliveryNote) => deliveryNote.id}
			label={t("incoming_invoices.delivery_notes.delivery_note")}
			placeholder={t("incoming_invoices.delivery_notes.select_delivery_note")}
			isRequired
			data-cy="incoming-invoice-delivery-note-picker"
		/>
	);
}
